<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>위생 교육</p></li>
            <li><p>식품 위생 교육 전문 기관</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>식품 위생 교육 전문 기관</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="form_table">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl_big">
                    <p>
                      (사)한국외식산업협회는 식품의약품안전처 지정 제1호
                      식품위생교육전문기관으로<br />
                      2014년 2월부터 식품위생교육을 실시하고 있습니다.
                    </p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="rule_list">
                    <ul class="rule_list_ul">
                      <li class="rule_list_li">
                        <div class="rule_list_ttl">
                          <h3 class="h3">교육 대상</h3>
                        </div>
                        <div class="rule_list_con">
                          <p>
                            일반음식점 영업자, 위탁급식영업의 영업자,
                            집단급식소의 설치·운영자
                          </p>
                        </div>
                      </li>
                      <li class="rule_list_li">
                        <div class="rule_list_ttl">
                          <h3 class="h3">전문기관 지정서</h3>
                        </div>
                        <div class="rule_list_con">
                          <img
                            src="@/assets/static/images/img_subscription.png"
                            alt=""
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'hygn-agency-index',
  description: '식품위생교육전문기관'
}
</script>

<style scoped></style>
